import type { ProfileConfig } from '@/components/views/accountManagement/registerWizard/steps/congratulations/profiles/profilesConfig'

/** Brand gradient per profile palette, used for hero cards and intro headers. */
export const PROFILE_GRADIENT: Record<ProfileConfig['colorPalette'], string> = {
  brand:
    'linear-gradient(135deg, var(--chakra-colors-brand-400) 0%, var(--chakra-colors-orange-400) 100%)',
  blue: 'linear-gradient(135deg, var(--chakra-colors-blue-400) 0%, var(--chakra-colors-blue-600) 100%)',
  pink: 'linear-gradient(135deg, var(--chakra-colors-pink-400) 0%, var(--chakra-colors-purple-500) 100%)',
}
